import React from "react";
import "./PageHeading.scss"
//@ts-ignore
import SimpleLineIcon from 'react-simple-line-icons';
import { navigate } from "@reach/router";

export interface PageHeadingProps {
    heading?: any;
    iconName?: any;
    fontSize?: any;
    fontWeight?: any;
    padding?: any;
    style?: any;
    onIconClick?(): void;
}

export interface PageHeadingState {

}

class PageHeading extends React.Component<PageHeadingProps, PageHeadingState> {
    public static defaultProps = {
        fontSize: '1em',
        padding: 0
    }
    constructor(props: PageHeadingProps) {
        super(props);
        this.state = {};
    }
    render() {
        const { padding, style, fontSize, fontWeight, heading, iconName, onIconClick} = this.props;
        return (
            <div className="page-heading" style={{ padding: padding, ...this.props.style  }}>
                <h1 style={{ fontSize: fontSize, fontWeight: fontWeight }}>{heading}</h1>
                <SimpleLineIcon name={iconName || ''} onClick={() => onIconClick && onIconClick()} />
            </div>
        );
    }
}

export default PageHeading;